<template>
  <div>
    <b-form-group
      :label="`${$t('teaching.instructionalMethod.fieldName')}:`"
      label-for="input-instructional-method-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-instructional-method-name"
        name="input-instructional-method-name"
        v-model="$v.instructional_method.name.$model"
        :state="validateState('name')"
        aria-describedby="input-instructional-method-name-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-instructional-method-name-live-feedback">
        {{ $t("reusable.common.minLength", { min: 3 }) }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      :label="`${$t('teaching.instructionalMethod.fieldDescription')}:`"
      label-for="input-instructional-method-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-textarea
        id="input-instructional-method-description"
        name="input-instructional-method-description"
        v-model="instructional_method.description"
        size="sm"
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-form-group>

    <div class="row mt-3">
      <div class="col" style="text-align: right">
        <b-button class="m-0 mr-1" size="sm" :disabled="saving" @click="save">
          {{ $t("reusable.common.save") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from "@/utils/utils";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import * as names from "@/store/names";

export default {
  name: "InstructionalMethodForm",
  mixins: [validationMixin],
  props: {
    // null => creación.
    InstructionalMethod: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      instructional_method: {
        name: this.InstructionalMethod ? this.InstructionalMethod.name : "",
        description: this.InstructionalMethod
          ? this.InstructionalMethod.description || ""
          : "",
      },
      saving: false,
    };
  },
  validations: {
    instructional_method: {
      name: {
        required,
        minLength: minLength(3),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.instructional_method[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.instructional_method.$touch();
      if (this.$v.instructional_method.$anyError) return;
      this.saving = true;
      const payload = {
        name: this.instructional_method.name.trim(),
        description: this.instructional_method.description,
      };
      const request = this.InstructionalMethod
        ? this.$store.dispatch(names.PATCH_INSTRUCTIONAL_METHOD, {
            instructional_method_id: this.InstructionalMethod.id,
            item: payload,
          })
        : this.$store.dispatch(names.POST_INSTRUCTIONAL_METHOD, payload);

      request
        .then((response) => {
          this.saving = false;
          toast(
            String(
              this.$t("teaching.instructionalMethod.methodEntity") +
                " " +
                (this.InstructionalMethod
                  ? this.$t("reusable.common.updated")
                  : this.$t("reusable.common.created"))
            )
          );
          this.$emit("saved", response);
        })
        .catch(() => {
          this.saving = false;
          toast(this.$t("teaching.instructionalMethod.saveError"));
        });
    },
  },
};
</script>

<style scoped>
.label {
  margin-top: 1%;
}
</style>
